import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  BannersAction, 
  setIsFetching, 
  setFetchFailed,
  setContent, 
} from 'Store/Banners/actions';

export const fetchBanners = () => {
  return async (dispatch: Dispatch<BannersAction>): Promise<void> => {
    const { isFetching } = Store.getState().banners;

    if (isFetching) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('StartPage');
      
      if (response.status === 200) {
        const content: Julius.Content.StartPage = await response.json();
        dispatch(setContent(content));
      } else {
        dispatch(setFetchFailed());
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/store/Banners/thunks.tsx